/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormFieldStructure } from './formFieldStructure';


export interface FormGroup { 
    formGroupTitle: string;
    formGroupId: string;
    formGroupName: string;
    formFields?: Array<FormFieldStructure>;
}

